<template>
    <AppHeaderDropdown>
        <template slot="header">
            <span class="active">OKR</span>
        </template>
        <template slot="dropdown">
            <b-dropdown-item exact :to="`/v2/profile/${currentUser.id}?activeTab=okr`">{{
                $t('okr.myOkrs')
            }}</b-dropdown-item>
            <b-dropdown-item to="/v2/okr/all-okrs">{{ $t('okr.allOkrs') }}</b-dropdown-item>
            <b-dropdown-item v-if="hasDaily" exact :to="`/v2/profile/${currentUser.id}?activeTab=myInitiatives`">{{
                $t('profile.tabs.myInitiatives')
            }}</b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
    name: 'DefaultOkrDropdown',
    components: {
        AppHeaderDropdown,
    },
    props: ['isAdmin', 'isLocalAdministrator', 'isOkrLeader', 'isGod', 'currentUser', 'hasDaily'],
}
</script>
